import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8878270"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-middle justify-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "active" }, "Present", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "Ways", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "Social", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "Web3", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_titleComp = _resolveComponent("titleComp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      class: _normalizeClass(["mt-3", _ctx.store.dark ? 'text-white' : 'text-black'])
    }, [
      _createVNode(_component_router_link, { to: "/past" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/ways" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ], 2),
    _createVNode(_component_titleComp, { class: "mx-7" }),
    _createElementVNode("nav", {
      class: _normalizeClass(["mt-3", _ctx.store.dark ? 'text-white' : 'text-black'])
    }, [
      _createVNode(_component_router_link, { to: "/social" }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/web3" }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ], 2)
  ]))
}